import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import t from 'react-translate';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import { CustomDataReportParams, UpdateReportSchedulingParams } from 'redux/schemas/api/custom-downloads';
import { addAlertMessage } from './alert-messages';

// eslint-disable-next-line import/prefer-default-export
export const toggleSftpReport = createAsyncThunk<boolean, CustomDataReportParams>(
  'TOGGLE_SFTP_REPORT',
  async ({ reportId, catalogId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${catalogId}/course_custom_data_report/${reportId}/toggle_sftp_report.json`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);

export const toggleDailyReport = createAsyncThunk<boolean, CustomDataReportParams>(
  'TOGGLE_DAILY_REPORT',
  async ({ catalogId, reportId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${catalogId}/course_custom_data_report/${reportId}/toggle_daily_email.json`);
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);

export const updateReportScheduling = createAsyncThunk<any, UpdateReportSchedulingParams>(
  'UPDATE_REPORT_SCHEDULING',
  async ({ catalogId, reportId, courseCustomDataReport }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.patch(`${catalogId}/course_custom_data_report/${reportId}/update_report_scheduling.json`, { courseCustomDataReport });
      return response.data.result;
    } catch (error) {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
      return rejectWithValue(error);
    }
  },
);
